<template>
  <div>
    <!-- {{ productList }} -->
    <!-- <b-btn @click="searchProductWithBarcode('1603942390046')">reader</b-btn> -->
    <v-select
      v-model="selected"
      @search="searchProduct"
      style="w-100"
      ref="product_select"
      :getOptionLabel="(option) => option.name + ' ' + option.reference_number"
      :options="productList"
      @input="showPickUnitAndBatchModal"
      :close-on-select="true"
      :autoscroll="true"
      placeholder="Select Product"
      class="pick_product_select"
    >
    </v-select>

    <PickProductUnitAndBatch
      @addProduct="addProductToBill"
      :data="selected"
      ref="PickProductUnitAndBatch"
    />
  </div>
</template>

<script>
import axios from "@/plugins/axios";
import { BillModel, BillDecorator } from "@/models/BillModel";
import PickProductUnitAndBatch from "@/components/shared/PickProductUnitAndBatch";
import { isNumber, isString } from "lodash";
import { mapState } from "vuex";

export default {
  name: "PickProduct",
  data: () => ({
    selected: null,
    productList: [],
  }),
  watch: {
    shop_info: {
      deep: true,
      handler: function () {
        this.searchProduct("");
        // this.$store.commit('bill/SET_PRODUCT', {})
        // this.productSelectedUnit = newVal.unit
      },
    },
  },
  components: {
    PickProductUnitAndBatch,
  },
  created: function () {
    this.searchProduct("");
    // this.$barcodeScanner.init(this.searchProductWithBarcode);
    // this.searchProduct();
  },
  computed: {
    ...mapState("shops", ["shop_info"]),
  },
  methods: {
    // callbackFunction(barcode) {
    // this.selected = barcode;
    // this.$refs.product_select.search = barcode;
    // this.searchProductWithBarcode(barcode);
    // alert("Barcode :" + barcode);
    // },
    searchProductWithBarcode(value) {
      //localhost:8080/api/v1.0/pos/shops/1/barcode-search?barcode=1603272297807
      axios
        .get("pos/shops/" + this.shop_info.id + "/product-search", {
          barcode: value,
        })
        .then((res) => {
          this.addProduct(res.data);
          // if (res.data.data.length == 1) {
          //   alert("unit and batch needed for adding process");
          //   this.addProduct(res.data.data[0]);
          // } else {
          //   this.productList = res.data.data;
          // }
        });
    },
    searchProduct(value) {
      // let isnum = /^\d+$/.test(value);

      // if (isnum) {
      //   this.searchProductWithBarcode(value);
      //   return;
      // }

      axios
        .get(`pos/shops/${this.shop_info ? this.shop_info.id : 1}/products`, {
          query: value,
        })
        .then((res) => {
          // if (res.data.data.length == 1) {
          //   alert("unit and batch needed for adding process");
          //   this.addProduct(res.data.data[0]);
          // } else {
          //   }
          this.productList = res.data.data;
        });
    },
    addProduct(product) {
      this.$store.dispatch("bill/AddProduct", product);
      // this.$emit("addProduct", product);
    },
    showPickUnitAndBatchModal() {
      this.$refs.PickProductUnitAndBatch.showModal();
    },
    addProductToBill(data) {
      if (this.selected) {
      }
      var product = this.selected;
      product.price = data.batch.selling_price;
      product.batch = data.batch;
      product.unit = data.unit;

      product.productInformation = data.productInformation;

      this.$store.dispatch(
        "bill/AddProduct",
        new BillDecorator(product).toBill()
      );
      this.selected = null;
    },
  },
};
</script>
